
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/data/www/musikum_portal/prod/.app/app.config.ts"
import cfg1 from "/data/www/musikum_portal/prod/layers/tairo-layout-collapse/app.config.ts"
import cfg2 from "/data/www/musikum_portal/prod/layers/tairo/app.config.ts"
import cfg3 from "/data/www/musikum_portal/prod/node_modules/.pnpm/@shuriken-ui+nuxt@1.1.3_magicast@0.3.5_nuxt@3.6.5_@parcel+watcher@2.5.1_@types+node@20.6.2_es_37odwak62n2scvgt2afd2l76ne/node_modules/@shuriken-ui/nuxt/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, inlineConfig)
